<template>
  <div class="inventory-wrapper">
    <!-- ── Left: Active Inventory Table ── -->
    <v-card
      class="inventory-card"
      elevation="1"
      rounded="lg"
      :loading="loading"
    >
      <!-- Card Header -->
      <div class="inv-header">
        <span class="inv-title">Current Firmware</span>
        <v-chip
          small
          class="total-chip"
        >
          {{ items.length }} TOTAL IMAGES
        </v-chip>
      </div>

      <!-- Table -->
      <v-simple-table class="inv-table">
        <template #default>
          <thead>
            <tr>
              <th>VERSION</th>
              <th>Charge Point ID</th>
              <th>Tenant Name</th>
              <th>Station Name</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, i) in items"
              :key="i"
            >
              <td>
                <div class="version-main">
                  {{ item.firmware_version }}
                </div>
                <!-- <div class="version-tag">
                  {{ item.firmware_version }}
                </div> -->
              </td>
              <td class="compat-cell">
                {{ item.charge_point_id }}
              </td>
              <td class="compat-cell">
                {{ item.tenant_name }}
              </td>
              <td class="date-cell">
                {{ item.location_name }}
              </td>
              <td class="date-cell">
                {{ item.date | formatDate }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  name: "ActiveInventoryDeployment",

  data() {
    return {
      steps: ["Select Build", "Target Assets", "Schedule"],
    };
  },
  computed: {
    ...mapGetters({
      loading: "firmware/getLoading",
      items: "firmware/getCurrentData",
    }),
  },
};
</script>

<style scoped>
/* ── Layout ── */
.inventory-wrapper {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

/* ══════════════════════════
   LEFT: INVENTORY CARD
══════════════════════════ */
.inventory-card {
  flex: 1;
  background: #ffffff !important;
  border: 1px solid #e8ecf0 !important;
  overflow: hidden;
}

/* Header */
.inv-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #f0f2f5;
}

.inv-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #4a5568;
  text-transform: uppercase;
}

.total-chip {
  background: #e8f5f0 !important;
  color: #1a7a5a !important;
  font-size: 10px !important;
  font-weight: 700 !important;
  letter-spacing: 0.08em !important;
  height: 22px !important;
  border-radius: 4px !important;
}

/* Table */
.inv-table {
  background: transparent !important;
}

.inv-table ::v-deep thead tr th {
  font-size: 9px !important;
  font-weight: 700 !important;
  letter-spacing: 0.1em !important;
  color: #9aa5b4 !important;
  text-transform: uppercase !important;
  border-bottom: 1px solid #f0f2f5 !important;
  padding: 10px 16px !important;
  vertical-align: top !important;
  line-height: 1.4 !important;
  white-space: normal !important;
}

.inv-table ::v-deep tbody tr {
  border-bottom: 1px solid #f7f8fa !important;
}

.inv-table ::v-deep tbody tr:last-child {
  border-bottom: none !important;
}

.inv-table ::v-deep tbody tr:hover {
  background: #f9fafb !important;
}

.inv-table ::v-deep tbody td {
  font-size: 12px !important;
  color: #2d3748 !important;
  padding: 14px 16px !important;
  vertical-align: middle !important;
  border-bottom: none !important;
}

/* Version cell */
.version-main {
  font-size: 12px;
  font-weight: 500;
  color: #1a202c;
}

.version-tag {
  font-size: 10px;
  color: #9aa5b4;
  font-weight: 400;
  margin-top: 2px;
}

/* Compat / Date */
.compat-cell {
  font-size: 11px !important;
  color: #4a5568 !important;
  max-width: 140px;
}

.date-cell {
  font-size: 11px !important;
  color: #9aa5b4 !important;
  white-space: nowrap;
}

/* Status badges */
.status-badge {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.status-badge.production {
  background: #e8f5f0;
  color: #1a7a5a;
  border: 1px solid #b2ddd0;
}

.status-badge.beta {
  background: #fffbeb;
  color: #92600a;
  border: 1px solid #f5d98a;
}

.status-badge.archived {
  background: #f3f4f6;
  color: #8a94a6;
  border: 1px solid #d1d5db;
}

/* Action buttons */
.action-btns {
  display: flex;
  /* flex-direction: column; */
  gap: 4px;
  align-items: center;
}

.action-icon {
  color: #9aa5b4 !important;
}

.action-icon:hover {
  color: #4a5568 !important;
}

.action-btns button {
  background-color: white !important;
}
/* ══════════════════════════
   RIGHT: DEPLOY CARD
══════════════════════════ */
.deploy-card {
  width: 200px;
  flex-shrink: 0;
  background: #0d2b2b !important;
  border: none !important;
  overflow: hidden;
}

.deploy-inner {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 20px 16px 16px;
  gap: 24px;
}

.deploy-top {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.deploy-title {
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.01em;
}

.deploy-sub {
  font-size: 11px;
  color: #6b9090;
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 8px;
}

/* Steps */
.deploy-steps {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
}

.deploy-step {
  display: flex;
  align-items: center;
  gap: 10px;
}

.step-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
  background: #1a4040;
  color: #6b9090;
}

.deploy-step.active .step-num {
  background: #2a6060;
  color: #7fffd4;
}

.step-label {
  font-size: 12px;
  font-weight: 500;
  color: #6b9090;
}

.deploy-step.active .step-label {
  color: #d0f0e8;
}

/* Launch button */
.launch-btn {
  background: #1a4a3a !important;
  color: #7fffd4 !important;
  font-family: "Sora", sans-serif !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em !important;
  text-transform: none !important;
  border-radius: 8px !important;
  height: 44px !important;
  margin-top: auto;
}

.launch-btn:hover {
  background: #1f5a46 !important;
}

/* ── Responsive ── */
@media (max-width: 680px) {
  .inventory-wrapper {
    flex-direction: column;
  }

  .deploy-card {
    width: 100%;
  }
}
</style>
